import { useApi } from '../swr/useApi';
import { currenciesService } from '../modules/api_client';
import type { CurrencyDto } from '../api';

export function useCurrencies() {
  const { data, error, isLoading } = useApi<CurrencyDto[]>(
    'currencies',
    () => currenciesService.getCurrencies(),
  );

  const currencyOptions = (data ?? []).map((c) => ({
    value: c.name,
    label: `${c.name} (${c.symbol})`,
  }));

  return { currencies: data ?? [], currencyOptions, error, isLoading };
}
